import { render, staticRenderFns } from "./CampaignPreview.vue?vue&type=template&id=ffc93106&scoped=true&"
import script from "./CampaignPreview.vue?vue&type=script&lang=js&"
export * from "./CampaignPreview.vue?vue&type=script&lang=js&"
import style0 from "./CampaignPreview.vue?vue&type=style&index=0&id=ffc93106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc93106",
  null
  
)

export default component.exports